import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

export default function usePaidMediaWeightsAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.PAID_MEDIA_WEIGHTS,
  )

  return isFeatureFlagEnabled
}
